import { AgricultureMapConstants, LAYER_TYPES, LOCATIONS_ZOOM_RANGE } from "src/app/main/constants/dims-map-constants";
import * as L from 'leaflet';

export const LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK', 'WARD']
export const ADMIN_LOCATION_HIE: any = ['COUNTRY', 'STATE', 'DISTRICT', 'BLOCK']
export const JAMMUEVENT_LAYER_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        // [NOWCAST_VIEW.ADMIN]: {
            // 'State Boundary': {
            //     source: 'INDIA',
            //     displayName: 'State',
            //     name: 'State Boundary',
            //     visible: true,
            //     // hasLegend: true,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layerptions_show_on_selector: false,
            //     layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
            //     layer_name: 'State Boundary',
            //     layeroptions_pane: 'depth',
            //     // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
            //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
            //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
            //     group: 'boundaries',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.VECTOR_LAYER,
            //     type: LAYER_TYPES.VECTOR_LAYER,
            //     cql_filter_value: null,
            //     cql_filter: null,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
            //     crs: 'EPSG4326',
            //     hasLables: true,
            //     applycql_filter: true,
            //     legendName: 'EUMETSAT_LEGEND',
            //     layeroptions_protocol: 'WFS'
            // },
            // 'State Boundaries': {
            //     source: 'INDIA',
            //     displayName: 'State Boundaries',
            //     name: 'State Boundaries',
            //     visible: true,
            //     view: AgricultureMapConstants.VIEWS.ADMIN,
            //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
            //     layerptions_show_on_selector: false,
            //     layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
            //     layer_name: 'State Boundaries',
            //     layeroptions_pane: 'depth',
            //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
            //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
            //     group: 'boundaries',
            //     group_type: 'radio-deselect',
            //     layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
            //     type: LAYER_TYPES.GEOJSON_LAYER,
            //     cql_filter_value: 'UUID',
            //     cql_filter: null,
            //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
            //     onEachFeature: 'handleAdminPolygons',
            //     environment_server_url: 'COMMON_GEOSERVER_URL',
            //     layeroptions_protocol: 'WFS'
            // },
            'District Boundaries': {
                source: 'INDIA',
                displayName: 'District Boundaries',
                name: 'District Boundaries',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
                layer_name: 'District Boundaries',
                layeroptions_pane: 'max',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
                type: LAYER_TYPES.GEOJSON_LAYER,
                cql_filter_value: 'UUID',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                onEachFeature: 'handleAdminPolygons',
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_protocol: 'WFS'
            },
            'District Boundary': {
                source: 'INDIA',
                displayName: 'District',
                name: 'District Boundary',
                visible: true,
                // hasLegend: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
                layer_name: 'District Boundary',
                layeroptions_pane: 'district',
                // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'EUMETSAT_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            'Block Boundary': {
                source: 'INDIA',
                displayName: 'Block',
                name: 'Block Boundary',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
                layer_name: 'Block Boundary',
                layeroptions_pane: 'state',
                // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.VECTOR_LAYER,
                type: LAYER_TYPES.VECTOR_LAYER,
                cql_filter_value: null,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
                crs: 'EPSG4326',
                hasLables: true,
                applycql_filter: true,
                legendName: 'EUMETSAT_LEGEND',
                layeroptions_protocol: 'WFS'
            },
            'State Boundary Labels': {
                source: 'INDIA',
                displayName: 'State',
                name: 'State Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_STATE',
                layer_name: 'State Boundary',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:INDIA_STATE_NAMES',
                crs: 'EPSG4326',
            },
            'District Boundary Labels': {
                source: 'INDIA',
                displayName: 'District Boundary Labels',
                name: 'District Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
                layer_name: 'District Boundary Labels',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'State_UUID',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
                crs: 'EPSG4326',
            },
            'Block Boundary Labels': {
                source: 'INDIA',
                displayName: 'Block Boundary Labels',
                name: 'Block Boundary Labels',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
                layer_name: 'Block Boundary Labels',
                layeroptions_pane: 'depth',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'Labels',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter_value: 'Dist_UUID',
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
                crs: 'EPSG4326',
            },
            'District Layer': {
                source: 'INDIA',
                displayName: 'District',
                name: 'District Layer',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
                layer_name: 'District Layer',
                layeroptions_pane: 'district',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN + 1,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
                crs: 'EPSG4326',
            },
            'Block Layer': {
                source: 'INDIA',
                displayName: 'Block',
                name: 'Block Layer',
                visible: true,
                view: AgricultureMapConstants.VIEWS.ADMIN,
                dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
                layerptions_show_on_selector: false,
                layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
                layer_name: 'Block Layer',
                layeroptions_pane: 'state',
                layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN - 2,
                layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
                group: 'boundaries',
                group_type: 'radio-deselect',
                layerServiceType: LAYER_TYPES.WMS_LAYER,
                type: LAYER_TYPES.WMS_LAYER,
                cql_filter: null,
                layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
                environment_server_url: 'COMMON_GEOSERVER_URL',
                layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
                crs: 'EPSG4326',
            }
        },
}
// export const JAMMUEVENT_LAYER_LIST: any = {
//     [AgricultureMapConstants.LOCATIONS.INDIA]: {
//         // 'KolkataOuter Boundaries': {
//         //     source: 'INDIA',
//         //     displayName: 'KolkataOuter Boundaries',
//         //     name: 'KolkataOuter Boundaries',
//         //     visible: true,
//         //     view: AgricultureMapConstants.VIEWS.ADMIN,
//         //     dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
//         //     layerptions_show_on_selector: false,
//         //     layeroptions_name: 'HEATWAVE:Kolkata_outerboundary',
//         //     layer_name: 'KolkataOuter Boundaries',
//         //     layeroptions_pane: 'depth',
//         //     layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MIN,
//         //     layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.VILLAGE].MAX,
//         //     group: 'boundaries',
//         //     group_type: 'radio-deselect',
//         //     layerServiceType: LAYER_TYPES.GEOJSON_LAYER,
//         //     type: LAYER_TYPES.GEOJSON_LAYER,
//         //     // cql_filter_value: 'UUID',
//         //     cql_filter: null,
//         //     layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
//         //     onEachFeature: 'handleAdminPolygons',
//         //     environment_server_url: 'COMMON_GEOSERVER_URL',
//         //     layeroptions_protocol: 'WFS'
//         // },
//         'District Boundary': {
//             source: 'INDIA',
//             displayName: 'District',
//             name: 'District Boundary',
//             visible: true,
//             // hasLegend: true,
//             view: AgricultureMapConstants.VIEWS.ADMIN,
//             dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
//             layerptions_show_on_selector: false,
//             layeroptions_name: 'HEATWAVE:ALL_INDIA_DISTRICT',
//             layer_name: 'District Boundary',
//             layeroptions_pane: 'district',
//             // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
//             layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 1,
//             layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
//             group: 'boundaries',
//             group_type: 'radio-deselect',
//             layerServiceType: LAYER_TYPES.VECTOR_LAYER,
//             type: LAYER_TYPES.VECTOR_LAYER,
//             cql_filter_value: null,
//             cql_filter: null,
//             layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
//             environment_server_url: 'COMMON_GEOSERVER_URL',
//             // layeroptions_styles: 'HEATWAVE:INDIA_DISTRICT_NAMES',
//             crs: 'EPSG4326',
//             hasLables: true,
//             applycql_filter: true,
//             legendName: 'HEATWAVE_LEGEND',
//             layeroptions_protocol: 'WFS'
//         },
//         'Block Boundary': {
//             source: 'INDIA',
//             displayName: 'Block',
//             name: 'Block Boundary',
//             visible: true,
//             view: AgricultureMapConstants.VIEWS.ADMIN,
//             dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
//             layerptions_show_on_selector: false,
//             layeroptions_name: 'HEATWAVE:ALL_INDIA_BLOCKS',
//             layer_name: 'Block Boundary',
//             layeroptions_pane: 'state',
//             // layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MIN,
//             layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.STATE].MIN - 2,
//             layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.DISTRICT].MAX,
//             group: 'boundaries',
//             group_type: 'radio-deselect',
//             layerServiceType: LAYER_TYPES.VECTOR_LAYER,
//             type: LAYER_TYPES.VECTOR_LAYER,
//             cql_filter_value: null,
//             cql_filter: null,
//             layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
//             environment_server_url: 'COMMON_GEOSERVER_URL',
//             // layeroptions_styles: 'HEATWAVE:ALL_INDIA_BLOCK_NAMES',
//             crs: 'EPSG4326',
//             hasLables: true,
//             applycql_filter: true,
//             legendName: 'HEATWAVE_LEGEND',
//             layeroptions_protocol: 'WFS'
//         },
//         'Ward Boundary': {
//             source: 'INDIA',
//             displayName: 'Ward Boundary',
//             name: 'Ward Boundary',
//             visible: true,
//             hasLegend: true,
//             view: AgricultureMapConstants.VIEWS.ADMIN,
//             dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
//             layerptions_show_on_selector: false,
//             layeroptions_name: 'HEATWAVE:KLKT_WARD_BOUNDARY',
//             layer_name: 'Ward Boundary',
//             layeroptions_pane: 'max',
//             layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
//             layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
//             group: 'Administrative Boundaries',
//             group_type: 'radio-deselect',
//             layerServiceType: LAYER_TYPES.WMS_LAYER,
//             type: LAYER_TYPES.WMS_LAYER,
//             cql_filter_value: null,
//             cql_filter: null,
//             layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
//             environment_server_url: 'COMMON_GEOSERVER_URL',
//             layeroptions_styles: 'HEATWAVE:WARD_BOUNDARY',
//             legendName: 'RADAR_LEGEND',
//             crs: 'EPSG4326',
//             applycql_filter: true
//         },
//         'Ward Boundary Labels': {
//             source: 'INDIA',
//             displayName: 'Ward Boundary Labels',
//             name: 'Ward Boundary Labels',
//             visible: true,
//             hasLegend: true,
//             view: AgricultureMapConstants.VIEWS.ADMIN,
//             dashboardView: AgricultureMapConstants.LOCATIONS.INDIA,
//             layerptions_show_on_selector: false,
//             layeroptions_name: 'HEATWAVE:KLKT_WARD_BOUNDARY',
//             layer_name: 'Ward Boundary Labels',
//             layeroptions_pane: 'max',
//             layeroptions_min_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MIN,
//             layeroptions_max_zoom: LOCATIONS_ZOOM_RANGE[AgricultureMapConstants.LOCATIONS.PANCHAYAT].MAX,
//             group: 'Administrative Boundaries',
//             group_type: 'radio-deselect',
//             layerServiceType: LAYER_TYPES.WMS_LAYER,
//             type: LAYER_TYPES.WMS_LAYER,
//             cql_filter_value: null,
//             cql_filter: null,
//             layerFrom: AgricultureMapConstants.SOURCES.GEOSERVER,
//             environment_server_url: 'COMMON_GEOSERVER_URL',
//             layeroptions_styles: 'HEATWAVE:WARD_LABELS_KLKT',
//             legendName: 'RADAR_LEGEND',
//             crs: 'EPSG4326',
//             applycql_filter: true
//         },
//     }
// }

export const EVENT_LEGEND_LIST: any = {
    [AgricultureMapConstants.LOCATIONS.INDIA]: {
        IMD_RADAR_MODEL_INPUT_NOWCAST: {
            RADAR_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '0'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '5'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '10'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '15'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '20'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#ffffff',
                        text: '25'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#ffffff',
                        text: '30'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '35'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '40'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '45'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '50'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#000000',
                        text: '55'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#000000',
                        text: '60'
                    },
                    {
                        backgroundColor: '#660000',
                        textColor: '#ffffff',
                        text: '65'
                    },
                    {
                        backgroundColor: '#ffcccc',
                        textColor: '#000000',
                        text: '>70'
                    },
                    // {
                    //   backgroundColor: '#ffcccc',
                    //   color: '#000000',
                    //   text: '75'
                    // }
                ],
                Units: 'dbZ'
            }
        },
        CTT_MODEL_INPUT_NOWCAST: {
            CTT_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: '#ffcccc',
                        textColor: '#000000',
                        text: '-93'
                    },
                    {
                        backgroundColor: '#e0b3b3',
                        textColor: '#000000',
                        text: '-85.5'
                    },
                    {
                        backgroundColor: '#9e1001',
                        textColor: '#ffffff',
                        text: '-78'
                    },
                    {
                        backgroundColor: '#b41b01',
                        textColor: '#ffffff',
                        text: '-70.5'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '-63'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '-55.5'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '-48'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '-40.5'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#ffffff',
                        text: '-33'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#ffffff',
                        text: '-20'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '-10'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '00.0'
                    },
                    {
                        backgroundColor: '#b3cce6',
                        textColor: '#000000',
                        text: '10.0'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '20.0'
                    },
                    {
                        backgroundColor: '#b3cce6',
                        textColor: '#000000',
                        text: '30.0'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '>40.0'
                    },
                    // {
                    //   backgroundColor: '#80aaff',
                    //   color: '#000000',
                    //   text: '50.0'
                    // },
                ],
                Units: '(°C)'
            }
        },
        EUMETSAT_NOWCAST: {
            EUMETSAT_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: '#e6eeff',
                        color: '#000000',
                        text: '0.5'
                    },
                    {
                        backgroundColor: '#80aaff',
                        color: '#000000',
                        text: '2.5'
                    },
                    {
                        backgroundColor: '#3377ff',
                        color: '#000000',
                        text: '5'
                    },
                    {
                        backgroundColor: '#003cb3',
                        color: '#000000',
                        text: '10'
                    },
                    {
                        backgroundColor: '#002266',
                        color: '#000000',
                        text: '20'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        color: '#000000',
                        text: '30'
                    },
                    {
                        backgroundColor: '#ff0066',
                        color: '#000000',
                        text: '40'
                    },
                    {
                        backgroundColor: '#cc0000',
                        color: '#000000',
                        text: '50'
                    },
                    {
                        backgroundColor: '#660000',
                        color: '#000000',
                        text: '75'
                    },
                    {
                        backgroundColor: '#ffcccc',
                        color: '#000000',
                        text: '>100'
                    },
                    // {
                    //   backgroundColor: '#ffcccc',
                    //   color: '#000000',
                    //   text: '1000'
                    // }
                ],
                Units: 'mm/hr'
            }
        },
        MODEL_INPUT_NOWCAST: {
            RAINFALL_LEGEND: {
                colorValues: [
                    {
                        backgroundColor: '#ffcccc',
                        textColor: '#000000',
                        text: '>100'
                    },
                    {
                        backgroundColor: '#660000',
                        textColor: '#000000',
                        text: '75-100'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#000000',
                        text: '50-75'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '40-50'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '30-40'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#000000',
                        text: '20-30'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#000000',
                        text: '10-20'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '5-10'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '2.5-5'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '0.5-2.5'
                    },
                    {
                        backgroundColor: 'transparent',
                        textColor: '#000000',
                        text: '0-0.5'
                    }
                ],
                Units: 'mm/hr'
            }
        },
        IMD_RADAR_NOWCAST: {
            RADAR_LEGEND: {
                "Units": "mm/hr ",
                "colorValues": [
                    {
                        backgroundColor: 'transparent',
                        textColor: '#000000',
                        text: '0-0.5 (no rainfall)'
                    },
                    {
                        backgroundColor: '#e6eeff',
                        textColor: '#000000',
                        text: '0.5-2.5'
                    },
                    {
                        backgroundColor: '#80aaff',
                        textColor: '#000000',
                        text: '2.5-5'
                    },
                    {
                        backgroundColor: '#3377ff',
                        textColor: '#000000',
                        text: '5-10'
                    },
                    {
                        backgroundColor: '#003cb3',
                        textColor: '#000000',
                        text: '10-20'
                    },
                    {
                        backgroundColor: '#002266',
                        textColor: '#ffffff',
                        text: '20-30'
                    },
                    {
                        backgroundColor: '#ff80b3',
                        textColor: '#000000',
                        text: '30-40'
                    },
                    {
                        backgroundColor: '#ff0066',
                        textColor: '#000000',
                        text: '40-50'
                    },
                    {
                        backgroundColor: '#cc0000',
                        textColor: '#000000',
                        text: '50-75'
                    },
                    {
                        backgroundColor: '#660000',
                        textColor: '#ffffff',
                        text: '75-100'
                    },
                ]
            }
        },
    }
}

export const JammuEventMapConstants: any = {
    HeatMapOptions: {
        type: 'Time',
        time: '24',
        clip: true,
        view: 'Admin',
        serviceType: 'HeatMap'
    }
}

export const SOURCE_VS_LEGEND: any = {
    IMD_RADAR_MODEL_INPUT_NOWCAST: 'RADAR_LEGEND',
    CTT_MODEL_INPUT_NOWCAST: 'CTT_LEGEND',
    EUMETSAT_MODEL_INPUT_NOWCAST: 'EUMETSAT_LEGEND',
    MODEL_INPUT_NOWCAST: 'RAINFALL_LEGEND',
}

export const JAMMUEVENT_TIMESTAMPLIST: any = {
EUMETSAT_NOWCAST : [
1756532700000,
1756528200000,
1756527300000,
1756526400000,
1756525500000,
1756524600000,
1756523700000,
1756522800000,
1756521900000,
1756521000000,
1756520100000,
1756519200000,
1756518300000,
1756517400000,
1756516500000,
1756515600000,
1756514700000,
1756513800000,
1756512900000,
1756512000000,
1756511100000,
1756510200000,
1756509300000,
1756508400000,
1756507500000,
1756506600000,
1756505700000,
1756504800000,
1756503900000,
1756503000000,
1756502100000,
1756501200000,
1756500300000,
1756499400000,
1756498500000,
1756497600000,
1756496700000,
1756495800000,
1756494900000,
1756494000000,
1756493100000,
1756492200000,
1756491300000,
1756490400000,
1756489500000,
1756488600000,
1756487700000,
1756486800000,
1756485900000,
1756485000000,
1756484100000,
1756483200000,
1756482300000,
1756481400000,
1756480500000,
1756479600000,
1756478700000,
1756477800000,
1756476900000,
1756476000000,
1756475100000,
1756474200000,
1756473300000,
1756472400000,
1756471500000,
1756470600000,
1756469700000,
1756468800000,
1756467900000,
1756467000000,
1756466100000,
1756465200000,
1756464300000,
1756463400000,
1756462500000,
1756461600000,
1756460700000,
1756459800000,
1756458900000,
1756458000000,
1756457100000,
1756456200000,
1756455300000,
1756454400000,
1756453500000,
1756452600000,
1756451700000,
1756450800000,
1756449900000,
1756449000000,
1756448100000,
1756447200000,
1756446300000,
1756445400000,
1756444500000,
1756443600000,
1756442700000,
1756441800000,
1756440900000,
1756440000000,
1756439100000,
1756438200000,
1756437300000,
1756436400000,
1756435500000,
1756434600000,
1756433700000,
1756432800000,
1756431900000,
1756431000000,
1756430100000,
1756429200000,
1756428300000,
1756427400000,
1756426500000,
1756425600000,
1756423800000,
1756422900000,
1756422000000,
1756421100000,
1756420200000,
1756419300000,
1756418400000,
1756417500000,
1756416600000,
1756415700000,
1756414800000,
1756413900000,
1756413000000,
1756412100000,
1756411200000,
1756410300000,
1756409400000,
1756408500000,
1756407600000,
1756406700000
],
RADAR_CTT_EUMETSAT_NOWCAST : [
1755367200000,
1755366600000,
1755366000000,
1755365400000,
1755364800000,
1755364200000,
1755363600000,
1755363000000,
1755362400000,
1755361800000,
1755361200000,
1755360600000,
1755360000000,
1755359400000,
1755358800000,
1755358200000,
1755357600000,
1755357000000,
1755356400000,
1755355800000,
1755355200000,
1755354600000,
1755354000000,
1755353400000,
1755352800000,
1755352200000,
1755351600000,
1755351000000,
1755350400000,
1755349800000,
1755349200000,
1755348600000,
1755348000000,
1755347400000,
1755346800000,
1755346200000,
1755345600000,
1755345000000,
1755344400000,
1755343800000,
1755343200000,
1755342000000,
1755341400000,
1755340800000,
1755340200000,
1755339600000,
1755339000000,
1755338400000,
1755337800000,
1755337200000,
1755336600000,
1755336000000,
1755335400000,
1755334800000,
1755334200000,
1755333600000,
1755333000000,
1755332400000,
1755331800000,
1755331200000,
1755330600000,
1755330000000,
1755329400000,
1755328800000,
1755328200000,
1755327600000,
1755325800000,
1755325200000,
1755324600000,
1755307800000,
1755307200000,
1755306600000,
1755306000000,
1755305400000,
1755304800000,
1755304200000,
1755303600000,
1755303000000,
1755302400000,
1755301800000,
1755301200000,
1755300600000,
1755300000000,
1755299400000,
1755298800000,
1755298200000,
1755297600000,
1755297000000,
1755296400000,
1755295800000,
1755295200000,
1755294600000,
1755294000000,
1755293400000,
1755292800000,
1755292200000,
1755291600000,
1755291000000,
1755290400000,
1755289800000,
1755289200000,
1755288600000,
1755288000000,
1755287400000,
1755286800000,
1755280800000,
1755280200000,
1755279600000,
1755279000000,
1755278400000,
1755277800000,
1755277200000,
1755276600000,
1755276000000,
1755275400000,
1755274800000,
1755274200000,
1755273600000,
1755273000000,
1755272400000,
1755271800000,
1755271200000,
1755270600000,
1755270000000,
1755269400000,
1755268800000,
1755268200000,
1755267600000,
1755267000000,
1755266400000,
1755265800000,
1755265200000,
1755264600000,
1755264000000,
1755263400000,
1755262800000,
1755262200000,
1755261600000,
1755261000000,
1755260400000,
1755259800000,
1755259200000,
1755258600000,
1755258000000,
1755257400000,
1755256800000,
1755256200000,
1755255600000,
1755255000000,
1755254400000,
1755253800000,
1755253200000,
1755252600000,
1755252000000,
1755251400000,
1755250800000,
1755250200000,
1755249600000,
1755248400000,
1755247800000,
1755247200000,
1755246600000,
1755246000000,
1755244800000,
1755244200000,
1755243600000,
1755243000000,
1755242400000,
1755241200000,
1755240600000,
1755240000000,
1755239400000,
1755238800000,
1755238200000,
1755237600000,
1755237000000,
1755235800000,
1755235200000,
1755234600000,
1755232800000,
1755231000000,
1755229200000,
1755227400000,
1755225600000,
1755223800000,
1755222000000,
1755220200000,
1755218400000,
1755216600000,
1755216000000,
1755215400000,
1755214800000,
1755214200000,
1755213600000,
1755213000000,
1755212400000,
1755211800000,
1755211200000,
1755210600000,
1755210000000,
1755209400000,
1755208800000,
1755208200000,
1755207600000,
1755207000000,
1755206400000,
1755205800000,
1755205200000,
1755204600000,
1755204000000,
1755203400000,
1755202800000,
1755202200000,
1755201600000,
1755201000000,
1755200400000,
1755194400000,
1755193800000,
1755193200000,
1755192600000,
1755192000000,
1755191400000,
1755190800000,
1755190200000,
1755189600000,
1755189000000,
1755188400000,
1755187800000,
1755187200000,
1755186600000,
1755186000000,
1755185400000,
1755184800000,
1755184200000,
1755183600000,
1755183000000,
1755182400000,
1755181800000,
1755181200000,
1755180600000,
1755180000000,
1755179400000,
1755178800000,
1755178200000,
1755177600000,
1755176400000,
1755175800000,
1755175200000,
1755174600000,
1755174000000,
1755173400000,
1755172800000,
1755172200000,
1755171600000,
1755171000000,
1755170400000,
1755169200000,
1755168600000,
1755168000000,
1755167400000,
1755166800000,
1755166200000,
1755165600000,
1755165000000,
1755164400000,
1755163800000,
1755163200000,
1755162000000,
1755161400000,
1755160800000,
1755160200000,
1755159600000,
1755159000000,
1755158400000,
1755157800000,
1755156600000,
1755156000000,
1755155400000,
1755154200000,
1755153000000,
1755152400000,
1755151800000,
1755151200000,
1755150600000,
1755149400000,
1755148800000,
1755148200000,
1755147600000,
1755147000000,
1755146400000,
1755145800000,
1755145200000,
1755144600000,
1755144000000,
1755143400000,
1755142200000,
1755141600000,
1755141000000,
1755140400000,
1755139800000,
1755138600000,
1755138000000,
1755137400000,
1755136800000,
1755136200000,
1755135600000,
1755135000000,
1755134400000,
1755133800000,
1755133200000,
1755132600000,
1755132000000,
1755131400000,
1755130800000,
1755130200000,
1755129600000,
1755129000000,
1755128400000,
1755127800000,
1755127200000,
1755126600000,
1755126000000,
1755125400000,
1755124800000,
1755124200000,
1755123600000,
1755123000000,
1755122400000,
1755121800000,
1755121200000,
1755120600000,
1755120000000,
1755119400000,
1755118800000,
1755118200000,
1755117600000,
1755117000000,
1755116400000,
1755115800000,
1755115200000,
1755114600000,
1755114000000,
],
IMD_RADAR_NOWCAST : [
1755369000000,
1755368400000,
1755367800000,
1755367200000,
1755366600000,
1755366000000,
1755365400000,
1755364800000,
1755364200000,
1755363600000,
1755363000000,
1755362400000,
1755361800000,
1755361200000,
1755360600000,
1755360000000,
1755359400000,
1755358800000,
1755358200000,
1755357600000,
1755357000000,
1755356400000,
1755355800000,
1755355200000,
1755354600000,
1755354000000,
1755353400000,
1755352800000,
1755352200000,
1755351600000,
1755351000000,
1755350400000,
1755349800000,
1755349200000,
1755348600000,
1755348000000,
1755347400000,
1755346800000,
1755346200000,
1755345600000,
1755345000000,
1755344400000,
1755343800000,
1755343200000,
1755342600000,
1755342000000,
1755341400000,
1755340800000,
1755340200000,
1755339600000,
1755339000000,
1755338400000,
1755337800000,
1755337200000,
1755336600000,
1755336000000,
1755335400000,
1755334800000,
1755334200000,
1755333600000,
1755333000000,
1755332400000,
1755331800000,
1755331200000,
1755330600000,
1755330000000,
1755329400000,
1755328800000,
1755328200000,
1755327600000,
1755327000000,
1755326400000,
1755325800000,
1755325200000,
1755324600000,
1755324000000,
1755323400000,
1755322800000,
1755322200000,
1755321600000,
1755321000000,
1755320400000,
1755319800000,
1755319200000,
1755318600000,
1755318000000,
1755317400000,
1755316800000,
1755316200000,
1755315600000,
1755315000000,
1755314400000,
1755313800000,
1755313200000,
1755312600000,
1755312000000,
1755311400000,
1755310800000,
1755310200000,
1755309600000,
1755309000000,
1755308400000,
1755307800000,
1755307200000,
1755306600000,
1755306000000,
1755305400000,
1755304800000,
1755304200000,
1755303600000,
1755303000000,
1755302400000,
1755301800000,
1755301200000,
1755300600000,
1755300000000,
1755299400000,
1755298800000,
1755298200000,
1755297600000,
1755297000000,
1755296400000,
1755295800000,
1755295200000,
1755294600000,
1755294000000,
1755293400000,
1755292800000,
1755292200000,
1755291600000,
1755291000000,
1755290400000,
1755289800000,
1755289200000,
1755288600000,
1755288000000,
1755287400000,
1755286800000,
1755286200000,
1755285600000,
1755285000000,
1755284400000,
1755283800000,
1755283200000,
1755282600000,
1755282000000,
1755281400000,
1755280800000,
1755280200000,
1755279600000,
1755279000000,
1755278400000,
1755277800000,
1755277200000,
1755276600000,
1755276000000,
1755275400000,
1755274800000,
1755274200000,
1755273600000,
1755273000000,
1755272400000,
1755271800000,
1755271200000,
1755270600000,
1755270000000,
1755269400000,
1755268800000,
1755268200000,
1755267600000,
1755267000000,
1755266400000,
1755265800000,
1755265200000,
1755264600000,
1755264000000,
1755263400000,
1755262800000,
1755262200000,
1755261600000,
1755261000000,
1755260400000,
1755259800000,
1755259200000,
1755258600000,
1755258000000,
1755257400000,
1755256800000,
1755256200000,
1755255600000,
1755255000000,
1755254400000,
1755253800000,
1755253200000,
1755252600000,
1755252000000,
1755251400000,
1755250800000,
1755250200000,
1755249600000,
1755249000000,
1755248400000,
1755247800000,
1755246600000,
1755246000000,
1755245400000,
1755244800000,
1755244200000,
1755243600000,
1755243000000,
1755242400000,
1755241800000,
1755241200000,
1755240600000,
1755240000000,
1755239400000,
1755238800000,
1755238200000,
1755237600000,
1755237000000,
1755236400000,
1755235800000,
1755235200000,
1755234600000,
1755234000000,
1755233400000,
1755232800000,
1755232200000,
1755231600000,
1755231000000,
1755230400000,
1755229800000,
1755229200000,
1755228600000,
1755228000000,
1755227400000,
1755226800000,
1755226200000,
1755225600000,
1755225000000,
1755224400000,
1755223800000,
1755223200000,
1755222600000,
1755222000000,
1755221400000,
1755220800000,
1755220200000,
1755219600000,
1755219000000,
1755218400000,
1755217800000,
1755217200000,
1755216600000,
1755216000000,
1755215400000,
1755214800000,
1755214200000,
1755213600000,
1755213000000,
1755212400000,
1755211800000,
1755211200000,
1755210600000,
1755210000000,
1755209400000,
1755208800000,
1755208200000,
1755207600000,
1755207000000,
1755206400000,
1755205800000,
1755205200000,
1755204600000,
1755204000000,
1755203400000,
1755202800000,
1755202200000,
1755201600000,
1755201000000,
1755200400000,
1755199800000,
1755199200000,
1755198600000,
1755198000000,
1755197400000,
1755196800000,
1755196200000,
1755195600000,
1755195000000,
1755194400000,
1755193800000,
1755193200000,
1755192600000,
1755192000000,
1755191400000,
1755190800000,
1755190200000,
1755189600000,
1755189000000,
1755188400000,
1755187800000,
1755187200000,
1755186600000,
1755186000000,
1755185400000,
1755184800000,
1755184200000,
1755183600000,
1755183000000,
1755182400000,
1755181800000,
1755181200000,
1755180600000,
1755180000000,
1755179400000,
1755178800000,
1755178200000,
1755177600000,
1755177000000,
1755176400000,
1755175800000,
1755175200000,
1755174600000,
1755174000000,
1755173400000,
1755172800000,
1755172200000,
1755171600000,
1755171000000,
1755170400000,
1755169800000,
1755169200000,
1755168600000,
1755168000000,
1755167400000,
1755166800000,
1755166200000,
1755165600000,
1755165000000,
1755164400000,
1755163800000,
1755163200000,
1755162600000,
1755162000000,
1755161400000,
1755160800000,
1755160200000,
1755159600000,
1755159000000,
1755158400000,
1755157800000,
1755157200000,
1755156600000,
1755156000000,
1755155400000,
1755154800000,
1755154200000,
1755153600000,
1755153000000,
1755152400000,
1755151800000,
1755151200000,
1755150600000,
1755150000000,
1755149400000,
1755148800000,
1755148200000,
1755147600000,
1755147000000,
1755146400000,
1755145800000,
1755145200000,
1755144600000,
1755144000000,
1755143400000,
1755142800000,
1755142200000,
1755141600000,
1755141000000,
1755140400000,
1755139800000,
1755139200000,
1755138600000,
1755138000000,
1755137400000,
1755136800000,
1755136200000,
1755135600000,
1755135000000,
1755134400000,
1755133800000,
1755133200000,
1755132600000,
1755132000000,
1755131400000,
1755130800000,
1755130200000,
1755129600000,
1755129000000,
1755128400000,
1755127800000,
1755127200000,
1755126600000,
1755126000000,
1755125400000,
1755124800000,
1755124200000,
1755123600000,
1755123000000,
1755122400000,
1755121800000,
1755121200000,
1755120600000,
1755120000000,
1755119400000,
1755118800000,
1755118200000,
1755117600000,
1755117000000,
1755116400000,
1755115800000,
1755115200000,
1755114600000,
1755114000000,
1755113400000,
1755112800000,
1755112200000,
1755111600000,
1755111000000,
1755110400000,
1755109800000,
]}

export const MARKERS_LATLONGS: any = [
    { name: "Kishtwar (Chositi area)", coords: [33.3200, 75.7700] },
    { name: "Kathua District (central)", coords: [32.5833, 75.5000] },
    { name: "Kathua City (municipal area)", coords: [32.3694, 75.5254] },
    { name: "French Wiki District entry", coords: [32.3700, 75.5233] }]